export default {"src":"/_next/static/media/two-factor.d8f92bc3.svg","height":62,"width":62,"blurWidth":0,"blurHeight":0};